<div class="row">
    <div class="col-24">
        <h3>Comment Information</h3>
    </div>
</div>
<div class="row">
    <div class="col-24">
        <div class="input-wrapper">
            <label for="add-comment">Add Comment</label>
            <input id="add-comment" type="text" [(ngModel)]="CommentinsertModel.Comment" />
        </div>
    </div>
</div>
<div class="row">
    <div class="col-24">
        <table class="table-striped table-hover custom-table">
            <tr>
                <th>Date Added</th>
                <th>Comments</th>
                <th>Added By</th>
            </tr>
            <tr *ngFor="let c of commentsViewModel">
                <td>{{c.RecCreateTS | dateFormat}}</td>
                <td>{{c.Comment}}</td>
                <td>{{c.RecCreateUserID}}</td>
            </tr>
        </table>
    </div>
</div>
<div class="row">
    <div class="col-24">
          <span style="color:red;font-size:14px;">{{errorMessage}}</span>
        </div>
        <div class="col-24">
            <button class="button primary" id="submit" [disabled]="this._global.currentUser.isAuditor" (click)="submitForm()">Save Comments</button>
        </div>
    </div>

